<template>
	<div class="UPLogin">
		<div class="UPTextStyle">
			账号密码登录
		</div>
		<div class="UPInput">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
				<input type="text" v-model.trim="ruleForm.userName" placeholder="请输入账号" class="userNameCss" />
				<input type="password" v-model.trim="ruleForm.password" placeholder="请输入密码" class="passWordCss" />
				<div @click="onSubmit" class="btn-OK-submit">登录</div>
				<!-- <div class="ForgetPassword" @click="ForgetPassWord">忘记密码></div> -->
			</el-form>
		</div>
	</div>
</template>

<script>
	import LoginCodeListRules from "../LoginFromList/LoginCodeList-rules"
	import LoginConfig from '../../../config/LoginConfig'
	import {
		Login,
		UserInfoMun
	} from '@/api/home'
	export default {
		data: function() {
			return {
				ruleForm: {
					userName: '',
					password: ''
				},
				rules: {}
			}
		},
		created() {
			this.EnterKeyDown()
		},
		mounted() {
			this.rules = JSON.parse(JSON.stringify(LoginCodeListRules))
		},
		methods: {
			// 回车登录
			EnterKeyDown() {
				let that = thiswo
				document.onkeydown = function(e) {
					if (that.$route.query.PageState == 2) {
						if (e.keyCode == 13) {
							that.onSubmit()
						}
					}
				}
			},
			// 登录事件
			async onSubmit() {
				const loading = this.$loading({
					lock: true,
					text: '登录中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let reslogin = await Login({
					userName: this.ruleForm.userName,
					password: this.$md5(this.ruleForm.password).toUpperCase()
				})
				if (reslogin.code == 0) {
					const startTime = new Date().getTime()
					// 保存登录时间
					localStorage.setItem("token-startTime", startTime)
					this.$store.commit("SET_TOKEN", reslogin.data.Token)
					this.$store.commit("SET_USERINFO", reslogin.data.user)
					this.userInfoMun()
				} else {
					this.$message({
						type: 'warning',
						message: reslogin.message
					});
				}
				loading.close();
			},
			// 菜单信息
			async userInfoMun() {
				const loading = this.$loading({
					lock: true,
					text: '加载菜单中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = await UserInfoMun({})
				if (res.code == 0) {
					this.$store.commit("MENUS_DATA", res.data)
					localStorage.setItem("MenusData", JSON.stringify(res.data))
					if (res.data.user.IsAppCustomer) {
						this.$router.replace({
							path: LoginConfig.LoginRouterOKUrlTemporary
						});
					} else {
						this.$router.replace({
							path: LoginConfig.LoginRouterOKUrl
						});
					}

					this.$message({
						type: 'success',
						message: '登录成功'
					});

					loading.close()
				} else {
					this.$notify.error({
						title: '菜单加载异常',
						message: res.message
					})
				}
			},
			ForgetPassWord() {
				this.$router.push({
					path: '/ForgetPassword'
				})
			}

		}
	}
</script>

<style lang='less' scoped>
	.UPLogin {
		//   border: 1px solid black;
		width: 89%;
		padding: 20px;
		user-select: none;

		.UPTextStyle {
			height: 90px;
			// border: 1px solid rebeccapurple;
			font-weight: bold;
			color: #424e66;
			line-height: 90px;
			font-size: 20px;
			padding-left: 40px;
		}

		.UPTextStyle::before {
			content: "";
			background: url("../../../assets/channel/login/leftLogin.png") no-repeat 0px 0px;
			position: absolute;
			top: 120px;
			left: 15px;
			// border: 1px solid red;
			width: 39px;
			height: 16px;
		}

		.UPInput {
			.userNameCss {
				width: 320px;
				height: 40px;
				border: 1px solid #e6e8eb;
				background: #fafbfc;
				border-radius: 2px;
				font-size: 14px;
				padding-left: 10px;
			}

			.passWordCss {
				width: 320px;
				height: 40px;
				border: 1px solid #e6e8eb;
				background: #fafbfc;
				border-radius: 2px;
				font-size: 14px;
				padding-left: 10px;
				margin-top: 20px;
			}

			.btn-OK-submit {
				width: 100%;
				height: 40px;
				background-color: #e71d43;
				text-align: center;
				font-size: 14px;
				color: #fff;
				font-family: "微软雅黑";
				border-radius: 2px;
				margin-top: 20px;
				line-height: 40px;
			}

			.CodeBtn {
				width: 120px;
				height: 40px;
				background-color: #e71d43;
				text-align: center;
				font-size: 14px;
				color: #fff;
				font-family: "微软雅黑";
				border-radius: 2px;
				margin-left: 15px;
				cursor: pointer;
			}

			.ForgetPassword {
				width: 100%;
				height: 20px;
				color: #9ca5b8;
				font-size: 14px;
				margin-top: 20px;
				margin-left: 270px;
			}
		}
	}
</style>
